import React, { FunctionComponent, useRef, useState } from "react";
import { Button, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import {
  AttachedResource,
  AttachedResourceType,
  AttachedToType,
} from "../../../../../../../../store/onboarding/cases/types";
import UploadUrlModal from "./UploadUrlModal";
import { toastr } from "react-redux-toastr";
import { bindActionCreators, Dispatch } from "redux";
import { uploadDocument } from "../../../../../../../../store/onboarding/actions";
import { connect } from "react-redux";
import AttachedResourceItem from "./AttachedResource";
import { vaildFileExtension } from "../../../../../../../../utils/files";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink, faUpload } from "@fortawesome/free-solid-svg-icons";

type DispatchProps = {
  uploadDocument: (attachedResource: AttachedResource) => any;
};

type OwnProps = {
  attachments?: AttachedResource[];
  onAttachmentsAdd: (resources: AttachedResource[]) => any;
  onAttachmentRemove?: (resourceId: number) => any;
};

type Props = OwnProps & DispatchProps;

const AddResourcesForm: FunctionComponent<Props> = (props) => {
  const { attachments, onAttachmentsAdd, onAttachmentRemove } = props;

  const uploadFileBtnRef = useRef<HTMLInputElement>(null!);
  const [fileUploading, setFileUploading] = useState<boolean>(false);
  const [showIEnterUrlForm, setShowEnterUrlForm] = useState<boolean>(false);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files; 
    
    const acceptedTypes = [
      ".doc",
      ".docx",
      ".jpg",
      ".jpeg",
      ".png",
      ".xlsx",
      ".pptx",
      ".pdf",
      ".txt",
      ".csv",
      ".ppt",
      ".pps"
    ];
    if (files) {
      for(let i in files){
        if(+i<=files.length) {
        const file =files[+i];
        if(!vaildFileExtension(file)) {
          return;
        }

        if(file.name.length > 100) {
          toastr.error("Alert", "The file name exceeds 100 characters. Please rename the file and try again.");
          return; // Exit the function if the file name exceeds the limit
        }
      
        const fileSizeInBytes = file?.size;
        const fileSizeInMB = fileSizeInBytes / (1024 * 1024); // Convert bytes to MB
    
        if (fileSizeInMB > 5) {
          toastr.error("Alert", "The file size exceeds 5 MB. Please upload a file smaller than 5 MB.");
          // return; // Exit the function if the file size exceeds the limit
        } else {
          const resourceFileType = file?.name.slice(file.name.lastIndexOf(".")).toLowerCase();
          if (acceptedTypes.includes(resourceFileType)) {
            const attachedResource: AttachedResource = {
              attached_to_type: AttachedToType.CHECKLIST_ITEM,
              resource_type: AttachedResourceType.FILE,
              attachment: file,
              title: file.name,
              mime_type: file.type,
            };
      
            setFileUploading(true);
            props.uploadDocument(attachedResource)
              .then(
                (resource: AttachedResource) => {
                  onAttachmentsAdd([resource]);
                },
                (err: string) => {
                  toastr.error("Failed to upload the attached file", err);
                }
              )
              .finally(() => {
                setFileUploading(false);
              });
          } else {
            toastr.error( "Alert",
              `This file format is not supported. Upload a DOC, DOCX, JPG, JPEG, PNG, XLSX, PPTX, PDF, TXT, CSV, PPT, or PPS file.`
              // `File type "${resourceFileType}" is not allowed.`, ''
            );
          }
        }
        }
      }
    }
  };
  
  return (
    <>
      <div className="interventionStepDetailResourceContainerEmpty">
        <label className="mb-2 d-block">
          <span className="font-weight-bold">Add Resources</span>
          <span className="text-muted small"> (Optional) </span>
        </label>
        {attachments && (
          <div className="interventionStepFileContainer mb-3">
            {attachments.map((attachment) => (
              <AttachedResourceItem
                attachment={attachment}
                onAttachmentRemove={onAttachmentRemove}
                key={attachment.id}
              />
            ))}
          </div>
        )}
        {/* <p className="mb-3">
          <span className="font-weight-bold">Accepted file types :</span> .doc, .docx, .jpg, .jpeg, .png, .xlsx, .pptx, .pdf, .txt, .csv, .ppt, .pps 
        </p> */}
        <OverlayTrigger
          trigger={["hover"]}
          placement="top"
          overlay={
            <Tooltip id="nextStepTooltip" className="customInfoTooltip">
              Upload a DOC, DOCX, JPG, JPEG, PNG, XLSX, PPTX, PDF, TXT, CSV, PPT, or PPS file under 5 MB with a file name of 100 characters or fewer.
            </Tooltip>
          }
        >
          <Button
            bsPrefix="b"
            className="blueBtnSm"
            onClick={() => uploadFileBtnRef.current.click()}
          >
            <FontAwesomeIcon
              icon={faUpload}
              size="sm"
              className="mr-1 pointer"
              style={{color:"#fff"}}
            />
            Upload File {fileUploading && <Spinner animation="border" size="sm" />}
          </Button>
        </OverlayTrigger>
        <input
        accept=".doc, .docx, .jpg, .jpeg, .png, .xlsx, .pptx, .pdf, .txt, .csv, .ppt, .pps"
          multiple
          ref={uploadFileBtnRef}
          style={{ display: "none" }}
          type="file"
          onChange={handleFileChange}
        />
        <Button
          bsPrefix="b"
          className="blueBtnSm"
          onClick={() => setShowEnterUrlForm(true)}
        >
          <FontAwesomeIcon
            icon={faLink}
            size="sm"
            className="mr-1 pointer"
            style={{color:"#fff"}}
          />
          Enter URL
        </Button>
      </div>

      {showIEnterUrlForm && (
        <UploadUrlModal
          onClose={() => setShowEnterUrlForm(false)}
          onAttachmentsAdd={onAttachmentsAdd}
        />
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => {
  return bindActionCreators(
    {
      uploadDocument: uploadDocument,
    },
    dispatch
  );
};

export default connect(null, mapDispatchToProps)(AddResourcesForm);
